import { Conversation, ConversationUpdateReason } from '@twilio/conversations';

import { getTwilioConversation } from './conversation';
import queryClient from '../queryClient';

export const lastReadMessageQueryKey = ['lastReadMessageIndex'];

type UpdateHandler = ({ updateReasons }: { updateReasons: ConversationUpdateReason[] }) => void;

const getReadIndex = (conversation: Conversation) => {
  return conversation.lastReadMessageIndex ?? 0;
};

export async function fetchLastReadMessageIndex() {
  const conversation = await getTwilioConversation();

  const handleUpdated: UpdateHandler = ({ updateReasons }) => {
    if (!updateReasons.includes('lastReadMessageIndex')) return;
    if (!conversation.lastReadMessageIndex) return;

    queryClient.setQueryData(lastReadMessageQueryKey, getReadIndex(conversation));
  };

  conversation.on('updated', handleUpdated);

  return getReadIndex(conversation);
}

export async function markAllAsRead() {
  const conversation = await getTwilioConversation();
  await conversation.setAllMessagesRead();
}

export async function markIndexAsRead(index: number) {
  const conversation = await getTwilioConversation();
  const lastIndex = conversation.lastReadMessageIndex ?? 0;

  if (index > lastIndex) {
    await conversation.updateLastReadMessageIndex(index);
  }
}
